export default {
  methods: {
    fileImgUrl(handle) {
      return this.$store.state.config.fileImgBaseUrl
        .replace(/\.jpg.+/, ".jpg")
        .replace("file_50x.jpg", `${handle}.jpg`);
    },
    fileUrl(filename) {
      return this.$store.state.config.fileImgBaseUrl
        .replace(/file_50x\.jpg.*/, filename);
    },
    assetImgUrl(handle, { size }) {
      return this.$store.state.config.assetImgBaseUrl
        .replace(/\.jpg.+/, ".jpg")
        .replace("asset_50x.jpg", `${handle}_${size}.jpg`);
    },
    assetUrl(filename) {
      return this.$store.state.config.assetBaseUrl
        .replace(/\.png.+/, ".png")
        .replace("asset.png", `${filename}`);
    },
  }
}